import { ApplicationConfigDefinition } from '../../shared/model/local/config/application-config-definition';
import { environment } from '../../../environment/environment';

export const ApplicationConfig: ApplicationConfigDefinition = {
  type: environment.type,
  applicationOwner: 'Visera',
  applicationName: 'Maxio Store',
  version: '0.1.0 (2025-06-09)',
  apiUrl: environment.apiUrl,
  production: environment.production,
  defaultLanguage: environment.defaultLanguage,
  gaId: environment.gaId,
  chargify: environment?.chargify,
};
